import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import days from './days.json'
import { LangContext } from "../LangContext.jsx";
class FrequencyCreator extends Component {
    constructor() {
        super();
        this.state = {
            period:'',
            every:1,
            ReferDayName:'Primero',
            monthFrequencyType:'number',
            dayOfWeek:1,
            repeatOnOptions: [
                { value: 1, label: 'Dias' },
                { value: 2, label: 'Semanas' },
                { value: 3, label: 'Meses' },
                { value: 4, label: 'Años' }
            ],
            dayOfWeekName:'Lunes',
            monthOfYear:1,
            monthOfYearName:'Enero',
            dayOfMonth:1, 
            day:1,
            dayName:'Lunes',
            frequencyType:'once',
            ReferDay:1,
            repeatEvery:1, 
            repeatOn:1,
            repeatOnName:'dias',
            cicles:1,
            ends:'never',
            days:days,
        }; 
    }
    updateParentStates = () => {  
        const allChildStates = { ...this.state }; 
        this.props.updateParentState(allChildStates);
    }
    async componentDidMount() {
        
        this.savePeriod();
        const { category } = this.props; 
        if (category == 2 && this.props.documentType != 5) {  
            this.setState({
                repeatOnOptions: [{ value: 3, label: 'Meses' }],
                repeatOn:3,
                repeatOnName:'meses',
                frequencyType:'yearly',
                frequency_key: 'yearly'
            },function(){
                this.savePeriod()
            });
        } else {
            this.setState({
                repeatOnOptions: [
                { value: 1, label: 'Dias' },
                { value: 2, label: 'Semanas' },
                { value: 3, label: 'Meses' },
                { value: 4, label: 'Años' }
                ]
            });
        }
        const document = this.props.document;
        if (document && typeof document === 'object' && !Array.isArray(document)) {
            this.setState({ 'cicles': document.cicles ?? 1 });
            this.setState({ 'day': document.day ?? 1 });
            this.setState({ 'dayOfWeek': document.day_of_week ?? 1 });
            this.setState({ 'every': document.every ?? 1 });
            this.setState({ 'type_id': document.type_id });
            let mft;
            (document.month_frequency_type == 1 ? mft = 'frequency' : mft = 'number');
            this.setState({ 'monthFrequencyType': mft });
            this.setState({ 'dayOfMonth': document.day_of_month ?? 1 });
            this.setState({ 'frequencyType': document.frequency ?? 'once' });
            this.setState({ 'frequency_key': document.frequency ?? 'once' });
            this.setState({ 'monthOfYear': document.month_of_year ?? 1 });
            this.setState({ 'period': document.period ?? 'Única' });
            this.setState({ 'ReferDay': document.refer_day ?? 1 });
            this.setState({ 'repeatOn': document.repeat_on ?? 1 });
            let ends;
            (document.ends == 1 ? ends = 'period' : ends = 'never');
            this.setState({ 'ends': ends });
        }
    }

    handleEveryChange = (e) => {
        this.setState({ every: e.target.value })
    }

    handleFrequencyPeriodChange = (e)=>{
        this.setState({ repeatOn: e.target.value })
        let name = ''
        e.target.value == 1 ? name = 'dia (s)': null;
        e.target.value == 2 ? name ='semana (s)': null;
        e.target.value == 3 ? name ='mes (es)': null;
        e.target.value == 4 ? name ='año (s)': null;
        this.setState({ repeatOnName: name })

        this.setState({ ReferDay: 1 })
        this.setState({ ReferDayName: 'Primer' })
        this.setState({ day: 1 })
        this.setState({ dayName: 'Lunes' })
    }
    handleDayOfWeekChange = (day)=>{
        this.setState({ dayOfWeek: day })
        let name
        day == 1 ? name = "Lunes" : null;
        day == 2 ? name = "Martes" : null;
        day == 3 ? name = "Miercoles" : null;
        day == 4 ? name = "Jueves" : null;
        day == 5 ? name = "Viernes" : null;
        day == 6 ? name = "Sabado" : null;
        day == 7 ? name = "Domingo" : null;
        this.setState({ dayOfWeekName: name })
    }
    handleMonthOfYearChange = (month)=>{
        this.setState({ monthOfYear: month })
        let name
        month == 1 ? name = "Enero" : null;
        month == 2 ? name = "Febrero" : null;
        month == 3 ? name = "Marzo" : null;
        month == 4 ? name = "Abril" : null;
        month == 5 ? name = "Mayo" : null;
        month == 6 ? name = "Junio" : null;
        month == 7 ? name = "Julio" : null;
        month == 8 ? name = "Agosto" : null;
        month == 9 ? name = "Septiembre" : null;
        month == 10 ? name = "Octubre" : null;
        month == 11 ? name = "Noviembre" : null;
        month == 12 ? name = "Diciembre" : null;
        this.setState({ monthOfYearName: name })
    }

    handleDayOfMonthChange = (day)=>{
        if(this.state.monthFrequencyType == 'number'){
            this.setState({ dayOfMonth: day })
        }
    }
    handleMonthFrequencyType = (e)=>{
        if(e.target.value == 'number'){
            this.setState({ dayOfMonth: 1 })
        }
        if(e.target.value == 'frequency'){
            this.setState({ dayOfMonth: 0 })
        }
        this.setState({ monthFrequencyType: e.target.value })
    }
    handleEndsChange = (e)=>{
        this.setState({ ends: e.target.value })
    }
    handleCicleChange = (e)=>{
        this.setState({ cicles: e.target.value })
        let name
        e.target.value == 1 ? name = "Primero" : null;
        e.target.value == 2 ? name = "Segundo" : null;
        e.target.value == 3 ? name = "Tercero" : null;
        e.target.value == 4 ? name = "Cuarto" : null;
        e.target.value == 5 ? name = "Quinto" : null;
        e.target.value == 6 ? name = "Último" : null;

        this.setState({ cicleName: name })
    }
    handleReferDayChange = (e)=>{
        this.setState({ ReferDay: e.target.value })
        let name
        e.target.value == 1 ? name = "Primero" : null;
        e.target.value == 2 ? name = "Segundo" : null;
        e.target.value == 3 ? name = "Tercero" : null;
        e.target.value == 4 ? name = "Cuarto" : null;
        e.target.value == 5 ? name = "Quinto" : null;
        e.target.value == 6 ? name = "Último" : null;

        this.setState({ ReferDayName: name })
    }
    handleDayChange = (e)=>{
        this.setState({ day: e.target.value })
        let name
        e.target.value == 1 ? name = "Lunes" : null;
        e.target.value == 2 ? name = "Martes" : null;
        e.target.value == 3 ? name = "Miercoles" : null;
        e.target.value == 4 ? name = "Jueves" : null;
        e.target.value == 5 ? name = "Viernes" : null;
        e.target.value == 6 ? name = "Sábado" : null;
        e.target.value == 7 ? name = "Domingo" : null;
        e.target.value == 8 ? name = "Día" : null;
        e.target.value == 9 ? name = "Día hábil" : null;
        e.target.value == 10 ? name = "Fin de semana" : null;
        this.setState({ dayName: name })
    }

    handleFrequencyChange = (e) =>{
        this.setState({ frequencyType: e.target.value },function(){
            this.savePeriod() 
        })
        this.setState({frequency_key: e.target.value})
    }

    savePeriod = ()=>{
        if(this.state.frequencyType == 'once'){
            this.setState({period:'Única'},function(){
                this.updateParentStates()
            })
        }else{
            let period = 'Repetir cada ' + this.state.every + ' ' + this.state.repeatOnName
            let end;
            let periodDescription = ''
            this.state.repeatOn == 2 ? periodDescription = ' el dia ' + this.state.dayOfWeekName: null ;
            if( this.state.repeatOn == 3){
                if(this.state.monthFrequencyType == 'number'){
                    periodDescription = ' el día ' + this.state.dayOfMonth;
                }
                if(this.state.monthFrequencyType == 'frequency'){
                    periodDescription = ' el ' + this.state.ReferDayName + ' ' + this.state.dayName;
                }
            }
            if( this.state.repeatOn == 4){
                    periodDescription = ' el ' + this.state.ReferDayName + ' ' + this.state.dayName + ' del mes de ' + this.state.monthOfYearName;
            }
            period += periodDescription
            this.state.ends == 'never' ? end = 'nunca' : end = 'despues de ' +this.state.cicles + ' repeticiones';
            period += ', termina ' +end
            this.setState({period:period},function(){
                this.updateParentStates()
            })
        } 

    }

    render() {
        return (
            <div className="col-sm-12 form-group">
                <label className="text-left">Frecuencia</label>
                <div className="d-flex ">
                    <div className=" d-flex"> 
                        {this.props.documentType <= 5 && (
                        <div className={ this.state.frequencyType == 'once' ? 'col-md-6  font-size-h4 selectedRadio' : 'col-md-6 font-size-h5 text-dark'}>
                            <input
                            type="radio"
                                value="once"
                                checked={this.state.frequencyType == 'once'} 
                                onChange={this.handleFrequencyChange}
                            /> Única
                        </div>
                        )}
                        <div className={ this.state.frequencyType == 'yearly'? 'col-md-12  font-size-h4 selectedRadio' : 'col-md-12 font-size-h5 text-dark '}>
                            <input
                                data-toggle="modal"
                                data-target="#modal"
                                type="radio"
                                value="yearly"
                                checked={this.state.frequencyType == 'yearly'} 
                                onChange={this.handleFrequencyChange}
                            /> Recurrente
                        </div>
                    </div>
                </div> 
                { this.state.frequency_key == 'yearly' &&
                    this.state.period
                }
                <div className="modal fade" id="modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                                            <div className="modal-dialog modal-dialog-centered modal-xl" role="document"> 
                                                <div className="modal-content text-dark-50   font-size-h5 font-weight-bolder "  >
                                                    <div className="modal-body px-15 py-10">
                                                        <h4 className="text-dark font-weight-bold my-1 mr-5">Personalizar Frecuencia</h4>
                                                        <div className="row mt-6">
                                                            <div className="col-sm-12 d-flex gap-1 align-items-center">
                                                                <div>
                                                                    Repetir cada
                                                                </div>
                                                                <div> 
                                                                <select value={this.state.every} id="document_system_id" className="form-control form-control-solid bg-white" onChange={this.handleEveryChange}>
                                                                        {(() => {
                                                                            let max = 1;
                                                                            if (this.state.repeatOn == 1) max = 365;
                                                                            else if (this.state.repeatOn == 2) max = 4;
                                                                            else if (this.state.repeatOn == 3) max = 12;
                                                                            else if (this.state.repeatOn == 4) max = 1;
                                                                            let option = [];
                                                                            for (let i = 1; i <= max; i++) {
                                                                                option.push(<option key={i} value={i}>{i}</option>);
                                                                            }
                                                                            return option  ;
                                                                        })()}
                                                                    </select>
                                                                </div>
                                                                <div>
                                                                    
                                                                    <select
                                                                    value={this.state.repeatOn}
                                                                    id="document_system_id"
                                                                    className="form-control form-control-solid bg-white"
                                                                    onChange={this.handleFrequencyPeriodChange}
                                                                >
                                                                    {this.state.repeatOnOptions.map(option => (
                                                                    <option key={option.vaue} value={option.value}>
                                                                        {option.label}
                                                                    </option>
                                                                    ))}
                                                                </select>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div className="row mt-6">
                                                            {this.state.repeatOn == 2 &&
                                                                <div className="col-sm-6 form-group">
                                                                <label className="text-left">Repetir en</label>
                                                                <div className="d-flex gap-1">
                                                                    <div onClick={ ()=> { this.handleDayOfWeekChange(1) } } className={ this.state.dayOfWeek == '1'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                        Lunes
                                                                    </div>
                                                                    <div onClick={ ()=> { this.handleDayOfWeekChange(2) }} className={ this.state.dayOfWeek == '2'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                        Martes
                                                                    </div>
                                                                    <div onClick={ ()=> { this.handleDayOfWeekChange(3) }} className={ this.state.dayOfWeek == '3'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                        Miercoles
                                                                    </div>
                                                                    <div onClick={ ()=> { this.handleDayOfWeekChange(4) }} className={ this.state.dayOfWeek == '4'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                        Jueves
                                                                    </div>
                                                                    <div onClick={ ()=> { this.handleDayOfWeekChange(5) }} className={ this.state.dayOfWeek == '5'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                        Viernes
                                                                    </div>
                                                                    <div onClick={ ()=> { this.handleDayOfWeekChange(6) }} className={ this.state.dayOfWeek == '6'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                        Sabado
                                                                    </div>
                                                                    <div onClick={ ()=> { this.handleDayOfWeekChange(7) }} className={ this.state.dayOfWeek == '7'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                        Domingo
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            }
                                                            {this.state.repeatOn == 3 &&
                                                                <div className="col-sm-12 form-group mt-5">
                                                                    <div className="row d-flex flex-column mt-5">
                                                                        <div className="col-md-12 gap-1 d-flex mt-5">
                                                                            <div className={ this.state.monthFrequencyType == 'number'? '   font-size-h5 selectedRadio' : '  font-size-h5'}>
                                                                                <input type="radio" value="number" checked={this.state.monthFrequencyType == 'number'} onChange={this.handleMonthFrequencyType}/> El día
                                                                            </div>
                                                                            <div className="d-flex flex-column gap-1" >
                                                                            <div className="d-flex gap-1 " >
                                                                                {(() => {
                                                                                    let div = [];
                                                                                    for (let i = 1; i <= 7; i++) {
                                                                                        div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                                                    }
                                                                                    return div;
                                                                                })()}
                                                                            </div>
                                                                            <div className="d-flex gap-1 " >
                                                                                {(() => {
                                                                                    let div = [];
                                                                                    for (let i = 8; i <= 14; i++) {
                                                                                        div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                                                    }
                                                                                    return div;
                                                                                })()}
                                                                            </div>
                                                                            <div className="d-flex gap-1 " >
                                                                                {(() => {
                                                                                    let div = [];
                                                                                    for (let i = 15; i <= 21; i++) {
                                                                                        div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                                                    }
                                                                                    return div;
                                                                                })()}
                                                                            </div>
                                                                            <div className="d-flex gap-1 " >
                                                                                {(() => {
                                                                                    let div = [];
                                                                                    for (let i = 22; i <= 28; i++) {
                                                                                        div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                                                    }
                                                                                    return div;
                                                                                })()}
                                                                            </div>
                                                                            <div className="d-flex gap-1 " >
                                                                                {(() => {
                                                                                    let div = [];
                                                                                    for (let i = 29; i <= 31; i++) {
                                                                                        div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                                                    }
                                                                                    return div;
                                                                                })()}
                                                                            </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.repeatOn == 4 &&
                                                            <div className="col-sm-12 form-group mt-5">
                                                                <div className="row d-flex flex-column mt-5">
                                                                <div className="col-md-12 gap-1  ">
                                                                    El
                                                                        <div className="d-flex align-items-center">
                                                                            <div className=" " >
                                                                                <select value={this.state.ReferDay} className="form-control form-control-solid bg-white" onChange={this.handleReferDayChange}>
                                                                                    <option value={1} selected default>Primero</option>
                                                                                    <option value={2}>Segundo</option>
                                                                                    <option value={3}>Tercero</option>
                                                                                    <option value={4}>Cuarto</option>
                                                                                    <option value={6}>Último</option>
                                                                                </select>
                                                                            </div>
                                                                            <div className=" " >
                                                                                <select value={this.state.day} className="form-control form-control-solid bg-white" onChange={this.handleDayChange}>
                                                                                    <option value={1} selected default>Lunes</option>
                                                                                    <option value={2}>Martes</option>
                                                                                    <option value={3}>Miercoles</option>
                                                                                    <option value={4}>Jueves</option>
                                                                                    <option value={5}>Viernes</option>
                                                                                    <option value={6}>Sábado</option>
                                                                                    <option value={7}>Domingo</option>
                                                                                        
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6 form-group">
                                                                        Mes
                                                                        <div className="d-flex gap-1 justify-content-between">
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(1) } } className={ this.state.monthOfYear == '1'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Enero
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(2) } } className={ this.state.monthOfYear == '2'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Febrero
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(3) } } className={ this.state.monthOfYear == '3'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Marzo
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(4) } } className={ this.state.monthOfYear == '4'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Abril
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6 form-group">
                                                                        <div className="d-flex gap-1 justify-content-between">
                                                                        <div onClick={ ()=> { this.handleMonthOfYearChange(5) } } className={ this.state.monthOfYear == '5'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Mayo
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(6) } } className={ this.state.monthOfYear == '6'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Junio
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(7) } } className={ this.state.monthOfYear == '7'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Julio
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(8) } } className={ this.state.monthOfYear == '8'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Agosto
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6 form-group">
                                                                        <div className="d-flex gap-1 justify-content-between">
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(9) } } className={ this.state.monthOfYear == '9'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Septiembre
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(10) } } className={ this.state.monthOfYear == '10'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Octubre
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(11) } } className={ this.state.monthOfYear == '11'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Noviembre
                                                                            </div>
                                                                            <div onClick={ ()=> { this.handleMonthOfYearChange(12) } } className={ this.state.monthOfYear == '12'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                                                Diciembre
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            }
                                                            <div className="col-sm-12 form-group mt-5">
                                                                    Termina
                                                                        <div className="row d-flex flex-column mt-5">
                                                                            <div className={ this.state.ends == 'never'? 'col-md-12  font-size-h5 selectedRadio'  : 'col-md-12 font-size-h5'}>
                                                                                <input type="radio" value="never" checked={this.state.ends == 'never'} onChange={this.handleEndsChange}/> Nunca
                                                                            </div>
                                                                            <div className="col-md-12 gap-1 d-flex align-items-center ">
                                                                                <div className={ this.state.ends == 'period'? '   font-size-h5 selectedRadio' : '  font-size-h5'}>
                                                                                    <input type="radio" value="period" checked={this.state.ends == 'period'} onChange={this.handleEndsChange}/> Despues de
                                                                                </div>
                                                                                <div className=" " >
                                                                                    <select value={this.state.cicles} className="form-control form-control-solid bg-white" onChange={this.handleCicleChange}>
                                                                                        <option value={1} selected default>1</option>
                                                                                        <option value={2}>2</option>
                                                                                        <option value={3}>3</option>
                                                                                        <option value={4}>4</option>
                                                                                        <option value={5}>5</option>
                                                                                        <option value={6}>6</option>
                                                                                        <option value={7}>7</option>
                                                                                        <option value={8}>8</option>
                                                                                        <option value={9}>9</option>
                                                                                        <option value={10}>10</option>
                                                                                        <option value={11}>11</option>
                                                                                        <option value={12}>12</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className="font-size-h5" >
                                                                                        Repeticiones
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            </div>
                                                        <div className="text-right gap-1">
                                                            <button type="button" className="btn btn-secondary mr-4" data-dismiss="modal">Cancelar</button>
                                                            <button onClick={ ()=> { this.savePeriod(); this.updateParentStates() } }  data-dismiss="modal" className="btn btn-primary font-weight-bolder px-10">
                                                                Guardar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            </div>
        )
    }
}

export default FrequencyCreator;

if (document.getElementById('FrequencyCreator')) {
    ReactDOM.render(<FrequencyCreator/>, document.getElementById('FrequencyCreator'));
}
